export const vessels = [
  {
    id: "aurum",
    name: "AURUM ONE",
    category: "mega",
    image: "https://images.unsplash.com/photo-1569263979104-865ab7cd8d13?q=80&w=1600&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1697124510322-27ef594f67fd?q=80&w=1400&auto=format&fit=crop",
      "https://images.pexels.com/photos/6752164/pexels-photo-6752164.jpeg?auto=compress&cs=tinysrgb&w=1400",
      "https://images.unsplash.com/photo-1782467330436-49eb6bf82ea3?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1598737285721-29346a5c9278?q=80&w=1400&auto=format&fit=crop",
    ],
    specs: { loa: "62 m", beam: "10.8 m", year: "2022", speed: "16 kn", guests: 12, cabins: 6, crew: 14 },
    price: "€210,000",
    featured: true,
  },
  {
    id: "sovereign",
    name: "ADRIA SOVEREIGN",
    category: "mega",
    image: "https://images.unsplash.com/photo-1567899378494-47b22a2ae96a?q=80&w=1600&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1674606867480-a3f97bd91533?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1674606878551-f424ad6ce965?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1785695583677-bb6cf19e274e?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1520250497591-112f2f40a3f4?q=80&w=1400&auto=format&fit=crop",
    ],
    specs: { loa: "55 m", beam: "9.6 m", year: "2020 / 2024", speed: "15 kn", guests: 12, cabins: 6, crew: 12 },
    price: "€175,000",
  },
  {
    id: "maltastar",
    name: "MALTA STAR",
    category: "mega",
    image: "https://images.pexels.com/photos/39242795/pexels-photo-39242795.jpeg?auto=compress&cs=tinysrgb&w=1600",
    gallery: [
      "https://images.unsplash.com/photo-1782467330477-cbfa4844c7c7?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1598448056086-307e98ef5c4a?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1758351820497-16de5afb5117?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1600812703042-38e573598898?q=80&w=1400&auto=format&fit=crop",
    ],
    specs: { loa: "47 m", beam: "9.0 m", year: "2019 / 2024", speed: "14 kn", guests: 10, cabins: 5, crew: 9 },
    price: "€140,000",
  },
  {
    id: "riviera",
    name: "RIVIERA SPIRIT",
    category: "motor",
    image: "https://images.unsplash.com/photo-1605281317010-fe5ffe798166?q=80&w=1600&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1678122878191-79b60410779f?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1782467330614-e725b4e2969b?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1598448154313-6e7789856d06?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1561501900-3701fa6a0864?q=80&w=1400&auto=format&fit=crop",
    ],
    specs: { loa: "34 m", beam: "7.3 m", year: "2021", speed: "22 kn", guests: 8, cabins: 4, crew: 5 },
    price: "€68,000",
  },
  {
    id: "sirocco",
    name: "SIROCCO",
    category: "sailing",
    image: "https://images.unsplash.com/photo-1540946485063-a40da27545f8?q=80&w=1600&auto=format&fit=crop",
    gallery: [
      "https://images.unsplash.com/photo-1781872324499-e51350ed640e?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1559827260-dc66d52bef19?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1544551763-46a013bb70d5?q=80&w=1400&auto=format&fit=crop",
      "https://images.unsplash.com/photo-1722032259251-91cc9365b349?q=80&w=1400&auto=format&fit=crop",
    ],
    specs: { loa: "36 m", beam: "8.2 m", year: "2018", speed: "10 kn", guests: 8, cabins: 4, crew: 4 },
    price: "€42,000",
  },
];

export const destinations = [
  {
    id: "riviera",
    image: "https://images.pexels.com/photos/11956743/pexels-photo-11956743.jpeg?auto=compress&cs=tinysrgb&w=1600",
    featured: true,
  },
  {
    id: "greece",
    image: "https://images.unsplash.com/photo-1533105079780-92b9be482077?q=80&w=1600&auto=format&fit=crop",
  },
  {
    id: "malta",
    image: "https://images.unsplash.com/photo-1736531966587-fe98ab5f8a79?q=80&w=1600&auto=format&fit=crop",
  },
  {
    id: "italy",
    image: "https://images.unsplash.com/photo-1516483638261-f4dbaf036963?q=80&w=1600&auto=format&fit=crop",
  },
  {
    id: "croatia",
    image: "https://images.unsplash.com/photo-1555990793-da11153b2473?q=80&w=1600&auto=format&fit=crop",
  },
];

export const IMAGES = {
  interior: "https://images.pexels.com/photos/6752164/pexels-photo-6752164.jpeg?auto=compress&cs=tinysrgb&w=1600",
  ocean: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?q=80&w=2000&auto=format&fit=crop",
};
